import useNotification from '../../../Hooks/useNotification.hook';

export default function useApiClient() {
	const { showNotificationAlert, showNotificationSuccess } = useNotification();

	const displayError = (e: any) => {
		if (e.response?.data?.displayableError) {
			showNotificationAlert({
				content: e.response.data.message,
			});
		}
	};

	const displaySuccess = (message: string) => {
		showNotificationSuccess({
			content: message,
		});
	};

	const displayGQLError = (result: any) => {
		const errors: { message: string }[] =
			result?.errors || result?.error?.errors || [];
		errors?.map(item => {
			showNotificationAlert({
				content: item.message,
			});
		});
	};

	return { displayError, displaySuccess, displayGQLError };
}
